// Mirrors the mobile app's src/utils/trial.js so the web admin enforces the
// same access rules: a superadmin "locked" suspension or an expired 5-day free
// trial blocks access. Computed client-side from the companies doc on every
// login and session restore, so no Firestore write is needed.

export const TRIAL_DAYS = 5;

function createdMillis(companyData) {
  const c = companyData && companyData.createdAt;
  if (!c) return null; // serverTimestamp not resolved yet → treat as not expired
  if (typeof c.toMillis === 'function') return c.toMillis();
  if (typeof c.seconds === 'number') return c.seconds * 1000;
  const t = new Date(c).getTime();
  return isNaN(t) ? null : t;
}

export function isTrialExpired(companyData) {
  const created = createdMillis(companyData);
  if (created == null) return false;
  return Date.now() > created + TRIAL_DAYS * 24 * 60 * 60 * 1000;
}

// Returns { blocked, reason } where reason is 'suspended' | 'trial' | null.
// A superadmin lock always blocks. The 5-day trial only blocks companies that
// haven't been marked paid — marking paid permanently removes the trial limit.
export function companyAccess(companyData) {
  if (!companyData) return { blocked: false, reason: null };
  if (companyData.locked) return { blocked: true, reason: 'suspended' };
  if (!companyData.paid && isTrialExpired(companyData)) return { blocked: true, reason: 'trial' };
  return { blocked: false, reason: null };
}

export function blockedMessage(reason) {
  if (reason === 'trial') {
    return 'Your 5-day free trial has ended. Please contact support to keep using OnShifts.';
  }
  return 'This account has been suspended. Please contact support.';
}
